import {useEffect, useState} from 'react'
import {UserUITheme} from 'yougile-model'
import {Storage} from '@client/storage'
import {globals} from '@extensions/globals-base'

export const useTheme = () => {
  const [theme, setTheme] = useState<UserUITheme>(globals.theme)

  useEffect(() => {
    const handleStorageChange = () => {
      const newTheme = Storage.getItem('theme') === 'dark' ? 'dark' : 'light'
      setTheme(newTheme)
    }

    const unsubscribe = Storage.subscribe(handleStorageChange)

    return () => {
      unsubscribe()
    }
  }, [])

  return theme
}
